export default {
  Private: require('./private').default,
  Public: require('./public').default
}